import { node } from "~/util/dom";
import { IRouteTypeSubitemItem } from "../const";
import { createRoutePremiumIconWithTooltip } from "./utils";

export default class ParamsItemSelectItem {
	_container: HTMLLIElement;

	_userIsPremium: boolean;

	_disabled: boolean;

	constructor(item: IRouteTypeSubitemItem, userIsPremium = false) {
		this._userIsPremium = userIsPremium;
		this._container = node("li", { innerHTML: `<p class="title">${item.label}</p>` });
		this._disabled = false;

		if (Mapy.CUS.route?.anotherCriterion && item.premium) {
			if (!this._userIsPremium) {
				this._disabled = true;
				this._container.classList.add("disabled");
				this._container.append(createRoutePremiumIconWithTooltip());
			}
		}
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {
	}

	get disabled() {
		return this._disabled;
	}

	get container() {
		return this._container;
	}

	set selected(selected: boolean) {
		this._container.classList[selected ? "add" : "remove"]("selected");
	}
}
